<div class="logo" [ngStyle]="{'border-color':gruppeFarge(), 'box-shadow': skygge()}" [matTooltip]="this.gruppetittel()">
  @if (url() && !erBlobUrl()) {
    <!-- height/width kreves av NgOptimizedImage, størrelsen overstyres uansett via css -->
    <img [ngSrc]="url()!" width="40" height="40" alt="logo"/>
  }@else if (url()) {
    <!-- ngSrc støtter ikke blob: url, da må src benyttes -->
    <img [src]="url()" width="40" height="40" alt="logo"/>
  } @else {
    <i class="ion-ios-people-outline"></i>
  }
</div>
